import { render, staticRenderFns } from "./ClientDebtPopUp.vue?vue&type=template&id=2a01b674&scoped=true&"
import script from "./ClientDebtPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientDebtPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientDebtPopUp.vue?vue&type=style&index=0&id=2a01b674&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01b674",
  null
  
)

export default component.exports